import { observer } from "mobx-react";
import { useEffect, useMemo, useState } from "react";
import OrderListing from "./order-listing";
import { useStores } from "../../stores/root-store";
import { useAuth } from "../../contexts/auth-context";
import { IOrder } from "../../stores/order";
import Paginate from "../../shared/pagination/paginate";
import { useOrderPaymentPolling } from "../../hooks/use-order-payment-polling";

const itemsPerPage = 10;

const ManageCustomerOrders = observer(() => {
  const { isAuthenticated, userId } = useAuth();
  const { orderStore } = useStores();
  const { orders, fetchCustomerOrders, refreshPaymentStatus } = orderStore;
  const [ordersPaginated, setOrdersPaginated] = useState<IOrder[]>([]);

  useEffect(() => {
    if (isAuthenticated && userId) fetchCustomerOrders(userId);
  }, [fetchCustomerOrders, isAuthenticated, userId]);

  useOrderPaymentPolling({
    enabled: isAuthenticated && !!userId,
    orders,
    checkPayment: refreshPaymentStatus,
    onPaid: () => fetchCustomerOrders(userId, true),
  });

  const orderList = useMemo(() => {
    return orders;
  }, [orders]);

  return (
    <div className="container-fluid">
      <div className="col-lg-9 mx-auto mt-3">
        <h5 className="text-start">My Orders</h5>
        <OrderListing orders={ordersPaginated} />
        <Paginate
          itemsPerPage={itemsPerPage}
          items={orderList}
          onPaginate={(orders: IOrder[]) => setOrdersPaginated(orders)}
        />
      </div>
    </div>
  );
});

export default ManageCustomerOrders;
